// @todo Add TS checks to this file
// https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#shopify-ajax-api-reference

/**
 * @param {string} endpoint The endpoint to fetch
 * @param {RequestInit} fetchOpts The options to merge with the default fetch options
 */
const apiRequest = async (endpoint, fetchOpts = {}) => {
  const res = await fetch(endpoint, Object.assign({
    method: 'get',
    credentials: 'same-origin'
  }, fetchOpts, {
    headers: Object.assign({
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      'cache-control': 'no-cache'
    }, fetchOpts.headers)
  }));

  if (!res.ok) {
    const responseData = await res.json();

    if (responseData.message && responseData.description) {
      throw new Error(responseData.message + ": " + responseData.description);
    }

    throw res.status;
  }

  return res.json();
};
/**
 * Makes an AJAX call to the /cart/change.js endpoint to update the quantity of an item
 * @see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#change-cart
 * @param {string} itemKey The CartItem's _key_ (not its id)
 * @param {number} quantity
 * @returns {Promise<undefined | import('../cart').Cart>} A Promise that resolves to either a cart if update was successful or otherwise nothing
 */


const changeCart = (itemKey, quantity) => apiRequest('/cart/change.js', {
  method: 'post',
  body: JSON.stringify({
    quantity,
    // The field name is `id`, but it is actually the item's `key`, not its `id`
    id: itemKey
  })
});
/**
 * Makes an AJAX call to the /cart/add.js endpoint to update the quantity of an item
 * @see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart
 * @param {{ quantity: number, id: number }[]} items Array of items to add. The `id` is the _variant_ id
 * @returns {Promise<undefined | {items: import('../cart-item').CartItem[]}>} A Promise that resolves to an array of line items (just the ones that were added)
 */

const addToCart = items => {
  return apiRequest('/cart/add.js', {
    method: 'post',
    body: JSON.stringify({
      items
    }),

    /**
     * Passing this header is required for the endpoint to return errors when there
     * are stock issues (and when data is passed as JSON, not serialized form data)
     * @TODO - Determine whether this should be used globally (e.g, also for
     * change or update)
     * @see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart
     * This reference indicates that Shopify examples (also Timber Ajax ATC) rely
     * on jQuery, which may add this header by default
     */
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
};
/**
 * Requests the given product by its handle
 * @see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-product
 * @param {string} handle
 * @returns {Promise<undefined | ProductJSON>}
 */

const getProduct = handle => apiRequest("/products/" + handle + ".js");
/**
 * Requests the entire cart
 * @see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart
 * @returns {Promise<undefined | import('../cart').Cart}
 */

const getCart = () => apiRequest('/cart.js');

export { addToCart as a, getProduct as b, changeCart as c, getCart as g };
